const PAIR_SYMBOL_TO_PAIR_ADDRESS = {
  USDC_USDT: "0x00e485d833099679ed7d121ce46a9557ea8ada1e",
};

const PAIR_ADDRESS_TO_REWARDS_POOL = {
  [PAIR_SYMBOL_TO_PAIR_ADDRESS.USDC_USDT]: 5,
};

const POOL_ID_TO_REWARDS_ADDRESSES = {
  [PAIR_ADDRESS_TO_REWARDS_POOL[PAIR_SYMBOL_TO_PAIR_ADDRESS.USDC_USDT]]: ["0x90708b20ccc1eb95a4fa7c8b18fd2c22a0ff9e78", "0x0be9e53fd7edac9f859882afdda116645287c629"],
};

const PAIR_ADDRESS_TO_REWARDS_LENGTH = {
};

module.exports = {
  ADDRESS: "0x182cd0c6f1faec0aed2ea83cd0e160c8bd4cb063",
  PAIR_SYMBOL_TO_PAIR_ADDRESS,
  POOL_ID_TO_REWARDS_ADDRESSES,
  PAIR_ADDRESS_TO_REWARDS_POOL,
  PAIR_ADDRESS_TO_REWARDS_LENGTH
};
